import { IcCaretRight } from '@magnetic/icons';
import React from 'react';
import { useNavContext } from '../nav-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavItemCaret = /* @__PURE__ */ __name(({
  isOpen
}) => {
  const { isCollapsed } = useNavContext();
  if (isOpen || isCollapsed) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(IcCaretRight, {
    "aria-hidden": "true",
    className: "mds-rebuild-nav-item-caret",
    role: "presentation"
  });
}, "NavItemCaret");

export { NavItemCaret };
//# sourceMappingURL=caret.js.map
